
export default function FactoryCooperationModelsSection() {
  const models = [
    {
      name: 'OEM代工合作',
      subtitle: '品牌授权生产',
      description: '工厂按照我们的标准和要求生产产品，使用我们的品牌进行销售，获得稳定的代工费用。',
      features: [
        '品牌授权使用',
        '技术标准提供',
        '原料统一采购',
        '质量全程监控',
        '销售渠道保障'
      ],
      benefits: [
        '稳定订单保障',
        '减少销售风险',
        '专业技术支持',
        '品牌价值提升'
      ],
      icon: 'ri-building-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/c6256744537e6bfea75a32afd5ccbe08.jpg'
    },
    {
      name: 'ODM产品开发',
      subtitle: '共同研发创新',
      description: '与工厂共同开发新产品，从配方研发到包装设计全程合作，共享产品知识产权和市场收益。',
      features: [
        '联合产品研发',
        '配方技术共享',
        '包装设计合作',
        '知识产权共有',
        '市场收益分成'
      ],
      benefits: [
        '技术创新提升',
        '产品差异化',
        '长期收益保障',
        '市场竞争优势'
      ],
      icon: 'ri-lightbulb-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Product development laboratory for tea innovation, researchers and technicians working on new tea formulations, collaborative R&D environment, innovative tea product development, modern laboratory equipment&width=400&height=250&seq=model-02&orientation=landscape'
    },
    {
      name: '战略伙伴合作',
      subtitle: '深度战略联盟',
      description: '建立长期战略合作伙伴关系，在资本、技术、市场等多个层面深度合作，共同发展壮大。',
      features: [
        '股权合作投资',
        '资源深度整合',
        '市场共同开拓',
        '技术联合创新',
        '品牌协同发展'
      ],
      benefits: [
        '资本实力增强',
        '资源优势互补',
        '风险共同承担',
        '发展前景广阔'
      ],
      icon: 'ri-handshake-line',
      color: 'from-blue-500 to-blue-600',
      image: 'https://readdy.ai/api/search-image?query=Strategic%20business%20partnership%20meeting%2C%20executives%20shaking%20hands%20in%20modern%20conference%20room%2C%20collaborative%20business%20alliance%2C%20long-term%20partnership%20agreement%2C%20professional%20corporate%20cooperation&width=400&height=250&seq=model-03&orientation=landscape'
    }
  ];

  return (
    <section id="cooperation-models" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            合作模式
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            提供多样化的合作模式，满足不同规模和发展阶段工厂的需求
          </p>
        </div>

        <div className="space-y-12">
          {models.map((model, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 lg:p-12">
              <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-8 lg:gap-12`}>
                <div className="flex-1">
                  <img
                    src={model.image}
                    alt={model.name}
                    className="w-full h-64 object-cover rounded-xl shadow-lg"
                  />
                </div>
                
                <div className="flex-1 space-y-6">
                  <div className="flex items-center space-x-4">
                    <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${model.color} flex items-center justify-center`}>
                      <i className={`${model.icon} text-white text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-800">{model.name}</h3>
                      <p className="text-base md:text-lg text-blue-600 font-medium">{model.subtitle}</p>
                    </div>
                  </div>
                  
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    {model.description}
                  </p>
                  
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="text-base md:text-lg font-semibold text-gray-800 mb-3">合作内容</h4>
                      <div className="space-y-2">
                        {model.features.map((feature, featureIndex) => (
                          <div key={featureIndex} className="flex items-center text-gray-700">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-3"></div>
                            <span className="text-xs md:text-sm">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <h4 className="text-base md:text-lg font-semibold text-gray-800 mb-3">合作优势</h4>
                      <div className="space-y-2">
                        {model.benefits.map((benefit, benefitIndex) => (
                          <div key={benefitIndex} className="flex items-center text-gray-700">
                            <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-3"></div>
                            <span className="text-xs md:text-sm">{benefit}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="text-lg md:text-2xl font-bold text-center text-gray-800 mb-8">合作模式对比</h3>
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-xl shadow-lg overflow-hidden">
              <thead className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
                <tr>
                  <th className="px-6 py-4 text-left text-xs md:text-sm">合作模式</th>
                  <th className="px-6 py-4 text-center text-xs md:text-sm">投资门槛</th>
                  <th className="px-6 py-4 text-center text-xs md:text-sm">收益方式</th>
                  <th className="px-6 py-4 text-center text-xs md:text-sm">合作周期</th>
                  <th className="px-6 py-4 text-center text-xs md:text-sm">适合工厂</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-gray-800 text-xs md:text-sm">OEM代工合作</td>
                  <td className="px-6 py-4 text-center text-green-600 text-xs md:text-sm">低</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">代工费用</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">1-3年</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">中小型工厂</td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-gray-800 text-xs md:text-sm">ODM产品开发</td>
                  <td className="px-6 py-4 text-center text-yellow-600 text-xs md:text-sm">中</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">销售分成</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">3-5年</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">有研发能力工厂</td>
                </tr>
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 font-semibold text-gray-800 text-xs md:text-sm">战略伙伴合作</td>
                  <td className="px-6 py-4 text-center text-red-600 text-xs md:text-sm">高</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">股权收益</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">5年以上</td>
                  <td className="px-6 py-4 text-center text-xs md:text-sm">大型优质工厂</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </section>
  );
}
